import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const ErrorBanner = ({ error, onDismiss }) => {
  if (!error) return null;

  // Extract HTTP status code if available
  const getStatusCode = (errorMessage) => {
    const statusMatch = errorMessage.match(/(\d{3})/);
    return statusMatch ? statusMatch[1] : null;
  };

  // Get short error message
  const getShortMessage = (errorMessage) => {
    if (errorMessage.includes('Authentication failed')) {
      return 'Authentication failed - check API key';
    }
    if (errorMessage.includes('Rate limit exceeded')) {
      return 'Rate limit exceeded - try again later';
    }
    if (errorMessage.includes('Network error')) {
      return 'Network error - check connection';
    }
    if (errorMessage.includes('Request timeout')) {
      return 'Request timeout - try again';
    }
    if (errorMessage.includes('Server error')) {
      return 'Server error - try again later';
    }
    if (errorMessage.includes('Bad request')) {
      return 'Bad request - check parameters';
    }
    if (errorMessage.includes('Resource not found')) {
      return 'Resource not found';
    }
    if (errorMessage.includes('Repeated cursor detected')) {
      return 'Pagination error - data may be incomplete';
    }
    
    // Default short message
    return errorMessage.length > 50 ? errorMessage.substring(0, 50) + '...' : errorMessage;
  };

  const statusCode = getStatusCode(error);
  const shortMessage = getShortMessage(error);

  return (
    <div className="error-banner">
      <div className="error-banner-content">
        <AlertTriangle size={20} className="error-icon" />
        <div className="error-details">
          {statusCode && (
            <span className="error-status">HTTP {statusCode}</span>
          )}
          <span className="error-message">{shortMessage}</span>
        </div>
        {onDismiss && (
          <button 
            onClick={onDismiss} 
            className="error-dismiss"
            aria-label="Dismiss error"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorBanner;


